import axios from 'axios';
import { helperGetApiHeaders, helperConvertApiRoute, apiErrorHandler } from 'helpers/ApiHelper';

export const FETCH_VIDEOS_TAB = 'FETCH_VIDEOS_TAB';

export function fetchVideosTab({ url, accessToken, deviceId = null }) {
  const request = axios
    .get(helperConvertApiRoute(url), helperGetApiHeaders({ accessToken, deviceId }))
    .catch(e => apiErrorHandler({ error: e }));
  return {
    type: FETCH_VIDEOS_TAB,
    payload: request,
  };
}
